import { FunctionComponent, SyntheticEvent, KeyboardEvent } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import MenuUnderHeaderIcon1 from '../../scss/images/menu-under-header-icon-1.svg';
import MenuUnderHeaderIcon2 from '../../scss/images/menu-under-header-icon-2.svg';
import MenuUnderHeaderIcon3 from '../../scss/images/menu-under-header-icon-3.svg';
import MenuUnderHeaderIcon4 from '../../scss/images/menu-under-header-icon-4.svg';

export const Menu: FunctionComponent = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const onKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.code === 'Enter') {
      const target = event.target as HTMLInputElement;

      navigate(`/blog/search/${target.value}`);
    }
  };

  const onSearch = (event: SyntheticEvent<HTMLElement>) => {
    event.preventDefault();

    const target = event.target as Element;

    const el = target.parentElement.querySelector('input') as HTMLInputElement;

    if (el.value.length === 0) {
      return false;
    }

    navigate(`/blog/search/${el.value}`);
  };

  return (
    <nav className="menu-under-header">
      <div className="menu-under-header-container">
        <ul>
          <li>
            <Link to="/blog">
              <div className="icon">
                <img src={MenuUnderHeaderIcon1} />
              </div>
              <span className="name">{t('blog tag news')}</span>
            </Link>
          </li>
          <li>
            <Link to="/blog/tag/case">
              <div className="icon">
                <img src={MenuUnderHeaderIcon2} />
              </div>
              <span className="name">{t('blog tag case')}</span>
            </Link>
          </li>
          <li>
            <Link to="/reviews/video">
              <div className="icon">
                <img src={MenuUnderHeaderIcon3} />
              </div>
              <span className="name">{t('blog tag reviews')}</span>
            </Link>
          </li>
          <li>
            <Link to="/case/free">
              <div className="icon">
                <img src={MenuUnderHeaderIcon4} />
              </div>
              <span className="name">{t('menu-under-header free case')}</span>
            </Link>
          </li>
        </ul>
        <div className="menu-under-header-search">
          <input type="text" placeholder="Поиск" onKeyDown={onKeyDown} />
          <a className="btn-search material-icons" href="#" onClick={onSearch}>
            search
          </a>
        </div>
      </div>
    </nav>
  );
};
